import PlayerListContainer from "../../components/PlayerListContainer";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useLocation, useNavigate } from 'react-router-dom';
import CustomButton from "../../components/CustomButton";
import Spinner from "../../components/Spinner";
import { toast } from 'react-toastify';
import { IoIosArrowDropleft } from "react-icons/io";


const RequestedToJoinList = () => {
    const { accessToken } = useSelector((state) => state.loginInfo);
    const location = useLocation();
    const { gameId } = location.state || {};
    const [playerData, setPlayerData] = useState();
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoader(true);
        const fetchApi = async () => {
            try {
                const result = await apiHandler({
                    url: `${endpoint.FETCH_REQUESTED_LIST}?gameId=${gameId}`,
                    method: "GET",
                    authToken: accessToken?.accessToken,
                });
                const response = result.data;
                console.log('response', response)
                if (response) {

                    const extractedData = response.map(item => ({
                        name: item?.baseProfile?.name,
                        distance: item.distance,
                        avatarName: item.baseProfile.avatarName,
                        avatarUrl: item.baseProfile.avatarUrl,
                        gender: item.baseProfile.gender,
                        reliabilityNum: item.baseProfile.reliabilityNum,
                        requestId: item.requestId,
                        age: item.baseProfile.age,
                        sport: item.userProfileResponse[0]?.gameName,
                        skillLevel: item.userProfileResponse[0]?.skillLevel
                    }));
                    setPlayerData(extractedData)
                    setLoader(false);
                }
                setLoader(false);
            } catch (error) {
                setLoader(false);
                console.error("Error fetching players:", error);
            }
        };
        fetchApi();
    }, [accessToken]);


    const onPlayerList = () => {

    }

    const handleButtonClick = (player, action) => {
        setLoader(true);
        const fetchApi = async () => {
            try {
                const result = await apiHandler({
                    url: `${endpoint.HOST_RESPONSE}?requestId=${player?.requestId}&action=${action}`,
                    method: "POST",
                    authToken: accessToken?.accessToken,
                });
                const response = result.data;
                console.log('response', response)
                if (response && response.code !== '500') {
                    toast.success(response.message)
                    navigate(-1)
                    setLoader(false);
                }
                else {
                    toast.error(response?.user_description)
                    setLoader(false);
                }

            } catch (error) {
                setLoader(false);
                console.error("Error fetching players:", error);
            }
        };
        fetchApi();
    }

    const onButton = (player) => (
        <>
            <div className="d-flex justify-content-between" style={{ width: '171px' }}>
                <CustomButton
                    id={`player-btn-${player.name}`}
                    buttonText={"Accept"}
                    onClick={() => handleButtonClick(player, true)}
                    style={{
                      
                        width: '80px',
                        height: '38px',
                        borderRadius: '12px',
                        color: 'rgb(0, 111, 253)',
                        border: '1px solid rgb(0, 111, 253)',
                        background: 'transparent',
                        cursor: 'pointer'
                    }}
                    className={`custom-player-button `}
                />
                <CustomButton
                    id={`player-btn-${player.name}`}
                    buttonText={"Reject"}
                    onClick={() => handleButtonClick(player, false)}
                    style={{
                        width: '80px',
                        height: '38px',
                        borderRadius: '12px',
                        color: 'rgb(255, 97, 109)',
                        border: '1px solid rgb(255, 97, 109)',
                        background: 'transparent',
                        cursor: 'pointer'
                    }}
                    className={`custom-player-button `}
                />
            </div>
        </>
    );
    const onGoToBackPage = () => {
        navigate(-1);
    }


    return (
        <div className="container p-3 p-sm-3">
            <div className='row mt-sm-3 g-3 ' >
                <div className="d-flex justify-content-start" >
                    <CustomButton
                        className="back-page-btn"
                        onClick={onGoToBackPage}
                        buttonText={
                            <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
                        }
                    />
                </div>

                {!loader ?
                    playerData?.length > 0 ? (
                        playerData.map((player, index) => (
                            <div className='col-lg-4' key={player.id}>
                                <PlayerListContainer
                                    player={player}
                                    onClick={onPlayerList}
                                    button={onButton(player)}
                                />
                            </div>
                        ))
                    ) : (
                        <div className="d-flex justify-content-center fs-4 mt-3">
                            <h2 className="text-center mt-3 fs-2" style={{ fontWeight: '600' }}>No Any New  Requested</h2>
                        </div>
                    )
                    :
                    <Spinner />
                }
            </div>
        </div>
    )
}
export default RequestedToJoinList;